import { render, staticRenderFns } from "./DriverMonit.vue?vue&type=template&id=53e39935&scoped=true&"
import script from "./DriverMonit.vue?vue&type=script&lang=js&"
export * from "./DriverMonit.vue?vue&type=script&lang=js&"
import style0 from "./DriverMonit.vue?vue&type=style&index=0&id=53e39935&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e39935",
  null
  
)

export default component.exports